<template>
  <el-dialog
    :visible.sync="showVideo"
    width="60%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="视频"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="view-video"
  >
    <video width="100%" height="400px" controls :src="videoSrc">
    </video>
  </el-dialog>
</template>

<script>
export default {
  name: "view-video",
  props:{
    show:{
      type:Boolean,
      default:false
    },
    videoSrc:{
      type:String,
      default:undefined
    }
  },
  watch:{
    show(v){
      this.showVideo=v
    }
  },
  data(){
    return{
      showVideo:false
    }
  },
  methods:{
    handleClose(){
      this.$emit("update:show",false)
    },
    handleOpen(){

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-view-club/component/view-club-main/video/index.vue